// extracted by mini-css-extract-plugin
export default {"root":"RangeFilterPopup_root__f+f50"};